import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var encode = function encode(locationInfo) {
  var stateNonLower = locationInfo.stateNonLower,
    dma = locationInfo.dma,
    statecounty = locationInfo.statecounty,
    statesubcounty = locationInfo.statesubcounty,
    alphaZone = locationInfo.alphaZone,
    zip = locationInfo.zip,
    isValid = locationInfo.isValid;
  if (isValid) {
    return "US|".concat(stateNonLower, "|").concat(zip, "|").concat(statecounty, "|").concat(dma, "|").concat(statesubcounty, "|").concat(alphaZone);
  }
  return '';
};
export var decodeAsAkami = function decodeAsAkami(locationString) {
  var location = decode(locationString);
  return {
    akamaidma: location.dma,
    akamaistatecounty: location.statecounty,
    akamaistatesubcounty: location.statesubcounty,
    akamaizip: location.zip,
    akamaizipcodeall: location.zip
  };
};
export var decode = function decode(locationString) {
  if (locationString) {
    var _locationString$split = locationString.split('|'),
      _locationString$split2 = _slicedToArray(_locationString$split, 7),
      country = _locationString$split2[0],
      stateNonLower = _locationString$split2[1],
      zip = _locationString$split2[2],
      statecounty = _locationString$split2[3],
      dma = _locationString$split2[4],
      statesubcounty = _locationString$split2[5],
      alphaZone = _locationString$split2[6];
    return {
      zip: zip,
      country: country,
      state: (stateNonLower || '').toLowerCase(),
      stateNonLower: stateNonLower,
      statecounty: statecounty,
      alphaZone: alphaZone,
      dma: dma,
      statesubcounty: statesubcounty,
      isValid: true
    };
  }
  return {};
};